import { RolesEnums } from '@/store/enums/RolesEnums';

const partnersProgram = {
  path: '/',
  redirect: '/partners-program',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/partners-program',
      name: 'partners-program',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/PartnersProgram.vue')
    }

  ]
};
export default partnersProgram;
